<template>
  <div id="map"></div>
</template>

<script>
import GoogleMapsLoader from 'google-maps'
GoogleMapsLoader.KEY = 'AIzaSyByk3YaE1ZOwvaOeJwuMWdv0i7TWbxdWfc'
GoogleMapsLoader.VERSION = '3.31'
export default {
  mounted () {
    var home = { lat: 40.4406, lng: -79.9959 }
    var el = document.getElementById('map')
    var options = {
      zoom: 10,
      zoomControl: false,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      maxZoom: 15,
      center: home,
      styles: [
        {
          'elementType': 'labels.text.fill',
          'stylers': [
            {
              'color': '#000000'
            }
          ]
        },
        {
          'elementType': 'labels.text.stroke',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'administrative',
          'elementType': 'geometry.fill',
          'stylers': [
            {
              'color': '#6cffb3'
            }
          ]
        },
        {
          'featureType': 'administrative',
          'elementType': 'geometry.stroke',
          'stylers': [
            {
              'color': '#000000'
            }
          ]
        },
        {
          'featureType': 'administrative.land_parcel',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'landscape',
          'stylers': [
            {
              'color': '#6cffb3'
            }
          ]
        },
        {
          'featureType': 'landscape.man_made',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'poi',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'road',
          'stylers': [
            {
              'color': '#88e3b4'
            },
            {
              'visibility': 'simplified'
            }
          ]
        },
        {
          'featureType': 'road',
          'elementType': 'labels',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'road.arterial',
          'elementType': 'geometry.fill',
          'stylers': [
            {
              'color': '#99d2b5'
            }
          ]
        },
        {
          'featureType': 'road.highway',
          'elementType': 'geometry.fill',
          'stylers': [
            {
              'color': '#99d2b5'
            }
          ]
        },
        {
          'featureType': 'transit',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'water',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '#2b9bff'
            }
          ]
        },
        {
          'featureType': 'water',
          'elementType': 'labels.text',
          'stylers': [
            {
              'color': '#ffffff'
            }
          ]
        }
      ]
    }
    var centerControlDiv = document.createElement('div')
    GoogleMapsLoader.load(function (google) {
      var gmap = new google.maps.Map(el, options)
      var marker = new google.maps.Marker({
        position: home,
        map: gmap,
        animation: google.maps.Animation.DROP,
        icon: require('@/assets/MapMarker.png')
      })
      marker.addListener('click', function () {
        if (marker.getAnimation() !== null) {
          marker.setAnimation(null)
        } else {
          marker.setAnimation(google.maps.Animation.BOUNCE)
        }
      })
      this.CenterControl(centerControlDiv, gmap, home)
      gmap.controls[google.maps.ControlPosition.TOP_CENTER].push(centerControlDiv)
    }.bind(this))
  },
  data: function () {
    return {
      msg: 'About Mathew'
    }
  },
  methods: {
    CenterControl (controlDiv, map, center) {
      var controlUI = document.createElement('div')
      controlUI.style.backgroundColor = '#fff'
      controlUI.style.border = '2px solid #fff'
      controlUI.style.borderRadius = '3px'
      controlUI.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)'
      controlUI.style.cursor = 'pointer'
      controlUI.style.textAlign = 'center'
      controlUI.title = "Click to recenter the map on Moose's Location."
      controlDiv.appendChild(controlUI)
      var controlText = document.createElement('div')
      controlText.style.color = 'rgb(25,25,25)'
      controlText.style.fontFamily = 'Roboto,Arial,sans-serif'
      controlText.style.fontSize = '16px'
      controlText.style.padding = '5px'
      controlText.innerHTML = 'Find Moose'
      controlUI.appendChild(controlText)
      controlUI.addEventListener('click', function () {
        map.panTo(center)
        map.setZoom(15)
      })
    }
  }
}

</script>
<style scoped>
#map {
  margin: 0 auto;
  min-height: 320px;
  height: 100%;
  width: 100%;
  background: gray;
}
</style>



// WEBPACK FOOTER //
// src/components/GoogleMap.vue